module.exports = __webpack_public_path__ + "static/media/ios-1.63813777.jpg";